/**
 * Shared full-bleed mobile shell for field check-in tools (sticky header + exit +
 * centered max-w-md main). Tool-agnostic primitive — used by Event Field Check-in;
 * the gun-show booth could adopt it later. An optional `offline` flag renders a
 * persistent offline strip.
 */
import { Link } from "react-router-dom";

interface Props {
  title: string;
  // Optional — a public/kiosk surface (e.g. /self-checkin) has nowhere to exit to, so
  // omit it and the header shows no exit link.
  exitTo?: string;
  exitLabel?: string;
  offline?: boolean;
  children: React.ReactNode;
}

export default function MobileCheckinShell({
  title,
  exitTo,
  exitLabel = "Exit",
  offline = false,
  children,
}: Props) {
  // #1: visually aligned with the public /redeem page — cream page, dark-red branded header, white cards.
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F5F1E8" }}>
      <header
        className="sticky top-0 z-20 flex items-center justify-between px-4 py-3 shadow-sm"
        style={{ backgroundColor: "#A02428" }}
      >
        <div>
          <div className="text-base font-bold leading-tight text-white">
            U.S. LawShield
          </div>
          <div className="text-xs text-white/80">{title}</div>
        </div>
        {exitTo && (
          <Link
            to={exitTo}
            className="text-sm font-medium text-white/90 hover:text-white"
          >
            {exitLabel}
          </Link>
        )}
      </header>
      {offline && (
        <div className="bg-amber-500 px-4 py-1.5 text-center text-xs font-medium text-white">
          Offline — entries are queued and will sync when you reconnect
        </div>
      )}
      <main className="mx-auto max-w-md px-4 py-4 space-y-4">{children}</main>
    </div>
  );
}
